import React from 'react'
import './ApplyV2ReviewApplyQuestions.scss'

const baseClass = 'ApplyV2ReviewApplyQuestions'

function ApplyV2ReviewApplyQuestions() {
    return <div>ApplyV2ReviewApplyQuestions</div>
}

export default ApplyV2ReviewApplyQuestions
